module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assets-wrap"
  }, [_c('z-scrollDiv', {
    staticClass: "bu-assets"
  }, [_c('div', {
    staticClass: "cycle-title"
  }, [_vm._v(_vm._s(_vm._f("cycleStr")(_vm.data.bonusCycleDetail)))]), _vm._v(" "), _c('div', {
    staticClass: "show-wrap"
  }, [_c('div', {
    staticClass: "show-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("奖金")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.bonus_curr.current_currency_balance)), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.bonus_curr.currency_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "show-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("预算")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.bonus_curr.currency_budget)), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.bonus_curr.currency_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "list-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/asset-icon-4.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("BU奖金明细")])]), _vm._v(" "), _c('div', {
    staticClass: "func-btn"
  }, [(_vm.data.isBonusDistributionOpen) ? _c('div', {
    staticClass: "front-btn orange",
    on: {
      "click": _vm.do_bonusAssign
    }
  }, [_vm._v("奖金分配")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "front-btn green hollow",
    on: {
      "click": function($event) {
        _vm.link('bu-bonus-detail')
      }
    }
  }, [_vm._v("查看明细")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/asset-icon-2.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("BU预算明细")])]), _vm._v(" "), _c('div', {
    staticClass: "func-btn"
  }, [_c('div', {
    staticClass: "front-btn orange hollow",
    on: {
      "click": function($event) {
        _vm.pop.budgetFlag = true
      }
    }
  }, [_vm._v("申请预算")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn green hollow",
    on: {
      "click": function($event) {
        _vm.link('bu-budget-detail')
      }
    }
  }, [_vm._v("查看明细")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/asset-icon-3.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("BU职级明细")]), _vm._v(" "), (_vm.data.isPromOpen) ? _c('span', {
    staticClass: "special"
  }, [_vm._v("当前可分配职级：" + _vm._s(_vm.rank_num + '级'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "func-btn"
  }, [(_vm.data.isPromOpen) ? _c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.do_rankAssign
    }
  }, [_vm._v("职级分配")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "front-btn green hollow",
    on: {
      "click": function($event) {
        _vm.link('bu-pmt-detail')
      }
    }
  }, [_vm._v("查看明细")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/asset-icon-1.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("BU罚单明细")])]), _vm._v(" "), _c('div', {
    staticClass: "func-btn"
  }, [_c('div', {
    staticClass: "front-btn green hollow",
    on: {
      "click": function($event) {
        _vm.link('bu-ticket-detail')
      }
    }
  }, [_vm._v("查看明细")])])])]), _vm._v(" "), _c('bonusShare', {
    attrs: {
      "showFlag": _vm.pop.bonusFlag,
      "assets": _vm.bonus_assign
    },
    on: {
      "close": function($event) {
        _vm.pop.bonusFlag = false
      },
      "getInfo": _vm.getData
    }
  }), _vm._v(" "), _c('rankShare', {
    attrs: {
      "pmt": _vm.data.pmtLevelSummary,
      "showFlag": _vm.pop.pmtFlag
    },
    on: {
      "close": function($event) {
        _vm.pop.pmtFlag = false
      },
      "getInfo": _vm.getData
    }
  }), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "form",
      rawName: "v-form:budget",
      arg: "budget"
    }],
    attrs: {
      "close-on-click-modal": false,
      "title": "预算申请",
      "visible": _vm.pop.budgetFlag
    },
    on: {
      "close": function($event) {
        _vm.budgetClose()
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "budgetFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请金额：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text mid"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.budgetAmount),
      expression: "pop.budgetAmount"
    }],
    attrs: {
      "rule": "noVal number positive",
      "placeholder": "请输入数字"
    },
    model: {
      value: (_vm.pop.budgetAmount),
      callback: function($$v) {
        _vm.$set(_vm.pop, "budgetAmount", $$v)
      },
      expression: "pop.budgetAmount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.task_curr.currency_name))])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.budgetReason),
      expression: "pop.budgetReason"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['申请理由']),
      expression: "['申请理由']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.budgetReason),
      expression: "pop.budgetReason"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入申请理由"
    },
    domProps: {
      "value": (_vm.pop.budgetReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "budgetReason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.budgetFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.pop.budget_loading
    },
    on: {
      "click": _vm.confirm_budget
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "form",
      rawName: "v-form:delay",
      arg: "delay"
    }],
    attrs: {
      "close-on-click-modal": false,
      "title": "延期申请",
      "visible": _vm.pop.delayFlag
    },
    on: {
      "close": function($event) {
        _vm.delayClose()
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "delayFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请BU：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.delay.bu_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请周期：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.delay.cycle_detail && ((_vm.delay.cycle_detail.cycle_year) + "#" + (_vm.delay.cycle_detail.cycle_number))))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.delayReason),
      expression: "pop.delayReason"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['申请理由']),
      expression: "['申请理由']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.delayReason),
      expression: "pop.delayReason"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入申请理由"
    },
    domProps: {
      "value": (_vm.pop.delayReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "delayReason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.delayFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.pop.delay_loading
    },
    on: {
      "click": _vm.confirm_delay
    }
  }, [_vm._v("提交申请")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0abe844f!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/page-assets.vue
// module id = 688
// module chunks = 1